export default __webpack_public_path__ + "static/media/screen3.9252e3c6.png";